import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static values = {
    url: String,
  };

  connect() {
    this._itemSortables = [];
    this._previousOrders = new WeakMap();
    this._initItemSortables();

    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: ".category-handle",
      ghostClass: "opacity-30",
      swapThreshold: 0.65,
      draggable: ".category-card",
      onStart: () => {
        this._previousOrders.set(this.sortable, this.sortable.toArray());
        this._setItemSortablesDisabled(true);
      },
      onEnd: () => {
        this._setItemSortablesDisabled(false);
        this._sendReorder(this.sortable, this.urlValue);
      },
    });
  }

  disconnect() {
    this._destroyItemSortables();
    this.sortable?.destroy();
  }

  // Private

  _initItemSortables() {
    this.element.querySelectorAll(".category-items").forEach((el) => {
      const url = el.dataset.itemOrderUrl;
      const sortable = Sortable.create(el, {
        animation: 150,
        handle: ".item-handle",
        ghostClass: "opacity-30",
        swapThreshold: 0.65,
        onStart: () => {
          this._previousOrders.set(sortable, sortable.toArray());
        },
        onEnd: () => {
          this._sendReorder(sortable, url);
        },
      });
      this._itemSortables.push(sortable);
    });
  }

  _destroyItemSortables() {
    this._itemSortables.forEach((s) => s.destroy());
    this._itemSortables = [];
  }

  _setItemSortablesDisabled(disabled) {
    this._itemSortables.forEach((s) => s.option("disabled", disabled));
  }

  async _sendReorder(sortable, url) {
    const ids = [...sortable.el.children]
      .filter((el) => el.dataset.id)
      .map((el) => el.dataset.id);
    const token = document.querySelector("[name='csrf-token']").content;

    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": token,
        },
        body: JSON.stringify({ ids }),
      });

      if (response.ok) {
        document.dispatchEvent(new CustomEvent("sortable-list:reorder"));
      } else {
        sortable.sort(this._previousOrders.get(sortable));
      }
    } catch {
      sortable.sort(this._previousOrders.get(sortable));
    }
  }
}
